import { ReactComponent as Delete } from '../../assets/delete.svg';
import { useCallback, useEffect, useState } from 'react';
import { AdminMember } from '../../models';
import adminService from '../../utils/api-calls/adminService';
import useAdminUser from '../../contexts/AdminUserContext';
import useLoading from '../../contexts/LoadingContext';
import { useTranslation } from 'react-i18next';
function Person({
  member,
  onDelete,
}: {
  member: AdminMember;
  onDelete: (email: string) => void;
}) {
  const adminUser = useAdminUser();
  const profile = adminUser.profile!;

  return (
    <div className="border-b border-gray-100 h-14 flex items-center pb-4 px-4">
      <div className="flex flex-col flex-grow">
        <span className="text-group-primary">{member.username}</span>
        <span className="text-xs text-gray-800">{member.email}</span>
      </div>
      {profile.email !== member.email ? (
        <button onClick={() => onDelete(member.email)}>
          <Delete />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
}

export default function PeopleManagement({
  onToggle,
  onAddAdmin,
}: {
  onToggle: () => void;
  onAddAdmin: () => void;
}) {
  const [t] = useTranslation(['common', 'admin']);
  const { setIsLoading } = useLoading();
  const [members, setMembers] = useState<AdminMember[]>([]);

  const getAdminMembers = useCallback(() => {
    adminService
      .getAdminMembers()
      .then((m) => setMembers(m))
      .finally(() => setIsLoading(false));
  }, [setIsLoading]);

  useEffect(() => {
    setIsLoading(true);
    getAdminMembers();
  }, [getAdminMembers, setIsLoading]);

  const onDelete = (email: string) => {
    setIsLoading(true);
    adminService.deleteAdminMember({ email }).then(() => getAdminMembers());
  };

  return (
    <div className="flex flex-col h-full w-full items-center pt-5 px-6 max-h-[500px]">
      <div className="flex items-center w-full relative">
        <span className="text-group-primary text-xl text-center font-medium flex-grow">
          {t('manage_account', '人員管理', { ns: 'admin' })}
        </span>
        <button
          className="flex items-center text-group-primary font-medium absolute right-0"
          onClick={onToggle}
        >
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>
      <span className="mt-5 mb-4 border-t w-full border-[#d9d9d9]"></span>
      <div className="w-full overflow-auto space-y-4 mb-6">
        {members.map((m) => (
          <Person member={m} key={m.id} onDelete={onDelete} />
        ))}
      </div>
      <button
        className="bg-group-primary text-white py-3 px-8 rounded text-center disabled:opacity-30 disabled:cursor-not-allowed mb-6"
        onClick={onAddAdmin}
      >
        {t('add_admin', '新增管理員', { ns: 'admin' })}
      </button>
    </div>
  );
}
